export default class EnterpriseDocument {
  public id = '';
  public title = '';
  public archived = false;
  public createdAt = '';

  constructor(options) {
    this.id = options.id;
    this.title = options.title;
    this.archived = options.archived;
    this.createdAt = options.createdAt;
  }
}
